





let lowestValue = Number.MAX_SAFE_INTEGER
let highestValue = Number.MIN_SAFE_INTEGER
const height = 500
const width = 900
const dataArray: number[] = []

function draw(dataArray: Array<number>) {
  const canvas =  (document.getElementById('canvas')) as HTMLCanvasElement
  const context = canvas?.getContext('2d')
  if (context) {
    context.clearRect(0, 0, width, height)
    context.fillStyle = '#dfac20';
    context.beginPath();
    context.moveTo(0, 0);
    dataArray.forEach(function (value,index) {
      context.lineTo(index as number, value as number);
    })
    context.stroke();
  }
}

const socket = new WebSocket('wss://api-pub.bitfinex.com/ws/2')

socket.onopen = function (event: Event): void {
  console.log('e:', event)
  socket.send(JSON.stringify({
    event: 'subscribe',
    channel: 'book',
    symbol: 'tBTCUSD'
  }))
}

function normalize (n: number, max: number){
  return (n / max)
}

function sigmoid (n: number){
  return 1/(1 + Math.exp(-n))
}

function avg (arr: Array<number>): number {
  return arr.reduce( (sume: number, el: number): number =>  { return sume + el }, 0) / arr.length
}

socket.onmessage = function (event: MessageEvent): void {
  const val = JSON.parse(event.data)[1][0]
  lowestValue = (lowestValue > val) ? val : lowestValue
  highestValue = (highestValue < val) ? val : highestValue
  let result = normalize(val - lowestValue, highestValue-lowestValue)
  result = result * height
  while(dataArray.length>width){
    dataArray.shift()
  }
  dataArray.push(result)
  draw(dataArray)
  console.log(val)
}

socket.onclose = function (event): void {
  if (event.wasClean) {
    console.log(`[close] Connection closed cleanly, code=${event.code} reason=${event.reason}`)
  } else {
    console.log('[close] Connection died')
  }
}

socket.onerror = function (error: Event): void {
  console.log('[error]', (error as any).message)
}
export default {
  name: 'Dashboard',
  components: {}
}
